<script>
    import {createEventDispatcher} from "svelte";
    import Nav from "./Nav.svelte";
    const dispatch = createEventDispatcher();

    export let opened = false;
    export let sections = [];
    export let favoritesList = [];

    const hasNavSections = sections.filter(item => item.sectionType !== 'text-block').length > 0;

    function scrollToSection (id) {
        dispatch('scrollToSection', {id});
    }

    function filterFavorites() {
        dispatch('filterFavorites');
    }
</script>

<style>
    .sections-container {
        position: sticky;
        top: 0;
        z-index: 100;
        width: 100%;
        margin: 0 0 .5rem 0;
    }
    .sections-block,
    .sections-block--content {
        background: var(--main-font-color);
        color: var(--bg-color);
        overflow-y: auto;
    }
    .sections-block {
        flex: 1 1;
    }
    .sections-container {
        display: flex;
    }
    ul {
        padding: 0 16px;
        font-family: Roboto Condensed, sans-serif;
        font-weight: 800;
        font-size: 16px;
        line-height: 1;
        text-transform: uppercase;

        display: flex;
        align-items: center;
        overflow-y: scroll;
    }
    li {
        display: flex;
        white-space: nowrap;
        padding: 16px 8px;
    }
    li.divider {
        padding: 14px 0;
    }

    @media (min-width: 768px) {
        .sections-container {
            padding-bottom: 2rem;
        }
        .sections-block--content {
            margin-left: -40px;
        }
        
        main {
            display: flex;
            justify-content: center;
        }
        ul {
            padding-left: 0;
            padding-right: 0;
        }
    }
</style>

{#if (!hasNavSections)}
    <hr class="separator full-width">
{:else}
    <div class="sections-container">
        <div class="sections-block hide-on-mobile"></div>
        <div class="sections-block sections-block--content container_768 container_960 container_1600">
            <Nav items={sections}
                 favorites={favoritesList || []}
                 on:filterFavorites={filterFavorites}
                 on:scrollToSection={(e) => scrollToSection(e.detail.id)}>
            </Nav>
        </div>
        <div class="sections-block hide-on-mobile"></div>
    </div>
{/if}
